<script setup lang="ts">
import { Banner } from '@dashhudson/dashing-ui/banner';
import { useCssVar, useElementSize } from '@vueuse/core';
import { computed, useTemplateRef, watch } from 'vue';

import { useBrowserVersionWarning } from '@/composables/useBrowserVersionWarning';

const { shouldShow, dismiss, browser } = useBrowserVersionWarning();

const browserLabel = computed(() => {
  if (browser.name === 'unknown') return 'your browser';
  return browser.name.charAt(0).toUpperCase() + browser.name.slice(1);
});

const message = computed(() =>
  browser.isIos
    ? 'Dash Social may not display correctly on this version of iOS. Please update iOS to the latest version for the best experience.'
    : `Dash Social may not display correctly on this version of ${browserLabel.value}. Please update to the latest version for the best experience.`,
);

const rootRef = useTemplateRef<HTMLDivElement>('root');
const { height } = useElementSize(rootRef);

const browserWarningOffset =
  typeof document === 'undefined'
    ? { value: '0px' }
    : useCssVar('--dash-top-banner-offset-browser-warning', document.documentElement);

watch(
  [shouldShow, height],
  () => {
    browserWarningOffset.value = shouldShow.value ? `${Math.ceil(height.value)}px` : '0px';
  },
  { immediate: true },
);
</script>

<template>
  <div
    v-if="shouldShow"
    ref="root"
    class="fixed! right-0! left-0! z-1000"
    :style="{ top: 'var(--dash-top-banner-offset-outage, 0px)' }"
  >
    <Banner
      title="Your browser is out of date"
      :message="message"
      severity="warn"
      class="w-full!"
      @close="dismiss"
      @action="() => {}"
    />
  </div>
</template>
